import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import {
  Button,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import { useStoreDispatch, useStoreSelector } from "../../../../../hooks/StoreHooks";
import { LayoutPage } from "../../../../../components/Layout/layoutPage";
import { useNavigate, useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { usePergolaConfigurationBuilderActions } from "../../../../../store/reducers/pergola_configuration_builder";
import { useConfigurationsServicePergola } from "../../../../services/pergola_service";
import { getCurrentUser } from "../../../../core/common_functions";

const Select = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { base, pergolaConfigurationBuilder } = useStoreSelector(store => store);
  const currentUser = getCurrentUser(base);
  const pergolaService = useConfigurationsServicePergola();
  const dispatcher = useStoreDispatch();
  const { setStepVisible, setStepActive} = usePergolaConfigurationBuilderActions();

  useEffect(() => {
    if (!id || isNaN(Number(id)) || !pergolaConfigurationBuilder.configuration) {
      navigate("/configurations");
    } else {
      dispatcher(setStepActive({ stepSlug: "selezione", isActive: true }));      
    }
  }, []);

  const handleStandardCardClick = () => {
    pergolaService.updateForma(currentUser, Number(id), "Standard");
    navigate(`/pergola-configurations/${id}`)
  };

  const handleFuoriSquadroCardClick = () => {
    pergolaService.updateForma(currentUser, Number(id), "FuoriSquadro");
    navigate(`/pergola-configurations/${id}`)
  };

  return (
    <LayoutPage>
      <div style={{ flex: "1 1 auto", minHeight: "0" }}>
        <div className="container h-full">
          <div className="row m-0 h-full">
            <div className="col-12 p-0" style={{ overflowY: "auto", height: "100%" }}>
              <div className="p-4">
                <h5 className="text-primary">Seleziona la forma della pergola</h5>
                <Grid container spacing={3} className="mt-3">
                  <Grid item xs={12} sm={6}>
                    <Card
                      sx={{
                        boxShadow: 5,
                        cursor: "pointer",
                        "&:hover": { boxShadow: 20 },
                      }}
                      onClick={handleStandardCardClick}
                    >
                      <div className={"flex justify-center w-full mt-6"}>
                        <img className={"object-contain"} alt={"Standard pergola"} />
                      </div>
                      <CardContent sx={{ textAlign: "center" }}>
                        <Typography variant="h5" component="div" fontWeight={"bold"} fontSize={18}>
                          Standard
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Card
                      sx={{
                        boxShadow: 5,
                        cursor: "pointer",
                        "&:hover": { boxShadow: 20 },
                      }}
                      onClick={handleFuoriSquadroCardClick}
                    >
                      <div className={"flex justify-center w-full mt-6"}>
                        <img className={"object-contain"} alt={"Fuori squadro pergola"} />
                      </div>
                      <CardContent sx={{ textAlign: "center" }}>
                        <Typography variant="h5" component="div" fontWeight={"bold"} fontSize={18}>
                          Fuori Squadro
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutPage>
  );
};

export default Select;